// Mock data for Elerein website

export const products = {
  consumer: [
    {
      id: 'e60-1',
      nameKey: 'e60Name',
      category: 'Ev ve Bahçe',
      image: 'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/xn5ghotx_e60%20havaliman%C4%B1.jpg',
      descriptionKey: 'e60Desc',
      link: '/products/e60',
      catalog: '#'
    },
    {
      id: 'prod-2',
      nameKey: 'compactName',
      category: 'Ev ve Bahçe',
      image: 'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/j7g4x7pp_Photoroom_20251103_231807.png',
      descriptionKey: 'e1Desc',
      link: '/products/compact',
      catalog: '#'
    }
  ],
  professional: [
    {
      id: 'e1',
      nameKey: 'e1Name',
      category: 'Profesyonel',
      image: 'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/v2pjvjqw_Photoroom_20251103_233504.png',
      descriptionKey: 'e1Desc',
      link: '/products/e1',
      catalog: 'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/nook83ge_ElereinT1a%20color%20change.pdf'
    },
    {
      id: 'e30',
      nameKey: 'e30Name',
      category: 'Profesyonel',
      image: 'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/t7w5h6ni_e30%20main.jpeg',
      descriptionKey: 'e30Desc',
      link: '/products/e30',
      catalog: '/catalog'
    },
    {
      id: 'e60',
      nameKey: 'e60Name',
      category: 'Profesyonel',
      image: 'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/orym4xwj_Photoroom_20251103_231840.png',
      descriptionKey: 'e60Desc',
      link: '/products/e60',
      catalog: '/catalog'
    },
    {
      id: 'e100',
      nameKey: 'e100Name',
      category: 'Profesyonel',
      image: 'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/chz8lnrn_Photoroom_20251103_231824.png',
      descriptionKey: 'e100Desc',
      link: '/products/e100',
      catalog: '/catalog'
    },
    {
      id: 'e130',
      nameKey: 'e130Name',
      category: 'Profesyonel',
      image: 'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/j11j0d0c_Photoroom_20251103_231814.png',
      descriptionKey: 'e130Desc',
      link: '/products/e130',
      catalog: '/catalog'
    },
    {
      id: 'e250',
      nameKey: 'e250Name',
      category: 'Profesyonel',
      image: 'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/c5mqf1mt_E250%20depo.jpg',
      descriptionKey: 'e250Desc',
      link: '/products/e250',
      catalog: '/catalog'
    }
  ]
};

export const featuredSections = [
  {
    id: 1,
    image: 'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/t7w5h6ni_e30%20main.jpeg',
    video: 'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/eekco1el_e30%20video.mp4',
    titleKey: 'featuredTechnologyTitle',
    descriptionKey: 'featuredTechnologyDesc',
    link: '/products/e30'
  },
  {
    id: 2,
    image: 'https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/bb2qxhis_Photoroom_20251103_231814.png',
    video: 'https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/619nq2x0_elerein%20130-60%20video.mp4',
    titleKey: 'featuredNewMachineTitle',
    descriptionKey: 'featuredNewMachineDesc',
    link: '/products/e130'
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800&q=80',
    titleKey: 'featuredCareerTitle',
    descriptionKey: 'featuredCareerDesc',
    link: '/about/career'
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=800&q=80',
    titleKey: 'featuredContactTitle',
    descriptionKey: 'featuredContactDesc',
    link: '/contact'
  }
];

export const navigationMenu = [
  {
    titleKey: 'products',
    submenu: [
      { titleKey: 'operationalRental', link: '/rental' },
      { titleKey: 'professional', link: '/professional' }
    ]
  },
  {
    titleKey: 'solutions',
    link: '/solutions'
  },
  {
    titleKey: 'service',
    link: '/service'
  },
  {
    titleKey: 'about',
    submenu: [
      { titleKey: 'company', link: '/about/company' },
      { titleKey: 'sustainability', link: '/about/sustainability' },
      { titleKey: 'career', link: '/about/career' }
    ]
  },
  {
    titleKey: 'contact',
    link: '/contact'
  }
];

export const footerLinks = {
  products: [
    { title: 'Operasyonel Kiralama', link: '/rental' },
    { title: 'Profesyonel Temizlik', link: '/professional' },
    { title: 'Zemin Temizleme Makinaları', link: '/products/floor-scrubbers' },
    { title: 'Dış Alan Süpürgeleri', link: '/products/sweepers' }
  ],
  services: [
    { title: 'Teknik Servis', link: '/service' },
    { title: 'Yedek Parça', link: '/spare-parts' },
    { title: 'Kiralama', link: '/rental' },
    { title: 'Eğitim', link: '/training' }
  ],
  company: [
    { title: 'Hakkımızda', link: '/about' },
    { title: 'Kariyer', link: '/career' },
    { title: 'Sürdürülebilirlik', link: '/sustainability' },
    { title: 'Basın', link: '/press' }
  ],
  support: [
    { title: 'İletişim', link: '/contact' },
    { title: 'SSS', link: '/faq' },
    { title: 'Dökümanlar', link: '/documents' },
    { title: 'Kataloglar', link: '/catalogs' }
  ]
};
